// extracted by mini-css-extract-plugin
module.exports = {"tagsInformation":"TagsInformation_tagsInformation__6eReI","h4":"TagsInformation_h4__1hl9m","infoItem":"TagsInformation_infoItem__K2UMQ","chips":"TagsInformation_chips__3dZUL"};